import { useContext } from 'react'
import { ActivationContext } from '../context/activationContextObject'

export const useActivation = () => useContext(ActivationContext)
